import { GuxTooltip } from "genesys-spark-components-react";
import "./PropertySection.less";

export function PropertySection({
    title,
    noBorderEnd,
    horizontalDisplay,
    children,
}: any) {
    const classNames = ["PropertySection"];
    if (noBorderEnd) {
        classNames.push("no-border-end");
    }
    if (horizontalDisplay) {
        classNames.push("horizontal-display");
    }
    return (
        <div className={classNames.join(" ")}>
            <div className="title">{title}</div>
            <div className="properties">{children}</div>
        </div>
    );
}

type PropertyProps = {
    name: string;
    checked: boolean | undefined;
    disabled?: boolean | undefined;
    label: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    tooltipText?: string;
};
export function Property({
    name,
    checked,
    disabled = undefined,
    label,
    onChange,
    tooltipText,
}: PropertyProps) {
    return (
        <span>
            <label className={disabled ? "" : "Clickable"}>
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    disabled={disabled}
                    aria-disabled={disabled}
                    onChange={onChange}
                    className={disabled ? "" : "Clickable"}
                />
                {label}
            </label>
            {tooltipText && <GuxTooltip>{tooltipText}</GuxTooltip>}
        </span>
    );
}
